import { baseModalLayoutDriverFactory } from '../BaseModalLayout/BaseModalLayout.legacy.driver';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

export const customModalLayoutDriverFactory = ({ element, eventTrigger }) => {
  deprecationTestkitLog(
    'customModalLayoutTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the CustomModalLayoutTestkit unidriver testkit instead.',
  );

  return {
    ...baseModalLayoutDriverFactory({ element, eventTrigger }),

    /** Returns if the modal content has padding */
    hasContentPadding: async () =>
      (await element.getAttribute('data-contentpadding')) === 'true',
  };
};
